// fetch licenses
export const getLicensesInit = 'GET_LICENSES_INIT';
export const getLicensesSuccess = 'GET_LICENSES_SUCCESS';
export const getLicensesError = 'GET_LICENSES_ERROR';

export const setLicenseListType = 'SET_LICENSE_LIST_TYPE';
